"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCompany = void 0;
/**
 * Delete a company from the companies table and emit a SNS event to delete the company from replicated tables
 */
var deleteCompany = function (instance) { return function (id, config) {
    return instance.delete("/users/companies/".concat(id), config);
}; };
exports.deleteCompany = deleteCompany;
